export enum SystemDataType {
    BANK_PERMISSION = "BANK_PERMISSION",
    ID_DOCUMENT = "ID_DOCUMENT",
    HAR_HABITUACH = "HAR_HABITUACH",
    DANEL_INVESTMENTS = "DANEL_INVESTMENTS",
    MONTHLY_COMMISSION = "MONTHLY_COMMISSION",
    PORTABILITY_REQUEST = "PORTABILITY_REQUEST",
    MEETING_SUMMARY = "MEETING_SUMMARY",
    PRE_ADVICE_SYSTEM = "PRE_ADVICE_SYSTEM",
    PUBLIC_ACTION_CONSENT = "PUBLIC_ACTION_CONSENT",
    VIEW_POLICIES_CONSENT = "VIEW_POLICIES_CONSENT",
    MORTGAGE_REPORT = "MORTGAGE_REPORT",
    INSURANCE_COVERAGE_REPORT = "INSURANCE_COVERAGE_REPORT",
    SALARY_SLIP = "SALARY_SLIP",
    BANK_TRANSFER_CONFIRMATION = "BANK_TRANSFER_CONFIRMATION",
    CLIENT_SIGNED_LETTER = "CLIENT_SIGNED_LETTER",
    CLIENT_SIGNED_FORM = "CLIENT_SIGNED_FORM", // a producer's form the client signed (forms engine)
    OTHER = "OTHER"
}
export interface FileMetadataDTO {
    system_data_type?: SystemDataType;
    target_handler_code?: string;
    custom_tag?: string;
    created_at?: string;
}

export interface StoredFileDTO extends FileMetadataDTO {
    name: string;
    full_path: string;
    url: string;
    last_modified: Date;
}